export const darkTheme = {
  colorScheme: "dark",
  globalStyles: (theme) => ({
    body: {
      ...theme.fn.fontStyles(),
      // backgroundColor: theme.colors.gray[0],
    },
  }),
};
